import { makeStyles } from 'tss-react/mui';

export const useOrderTableStyles = makeStyles()(theme => {
  return {
    img: {
      width: '50px',
      maxHeight: 65,
      cursor: 'pointer',
      borderRadius: 4,
      [theme.breakpoints.down('sm')]: {
        maxHeight: 80,
      },
    },
    card: {
      width: '97%',
      paddingLeft: 0,
      marginTop: 6,
      marginBottom: 0,
      [theme.breakpoints.down('sm')]: {
        width: '100%',
      },
      background: theme.palette.grey[100],
    },
    cardFooter: {
      width: '97%',
      paddingLeft: 0,
      marginTop: 6,
      marginBottom: 16,
      [theme.breakpoints.down('sm')]: {
        width: '100%',
      },
      background: theme.palette.grey[100],
    },
    contentWrapper: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
    },
    infoWrapper: {
      marginLeft: 20,
      width: '100%',
      [theme.breakpoints.down(365)]: {
        marginLeft: 13,
      },
      [theme.breakpoints.down(350)]: {
        marginLeft: 4,
      },
    },
    link: {
      marginRight: theme.spacing(3),
      fontSize: 20,
      color: '#000000',
      fontWeight: 'normal',
      height: 32,
    },
    infoButtonsWrapper: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'start',
      [theme.breakpoints.down('sm')]: {
        display: 'flex',
        flexDirection: 'column',
      },
    },
    typeList: {
      backgroundColor: 'white',
      maxWidth: 200,
    },
    tableContainer: {
      paddingRight: theme.spacing(2),
      paddingLeft: 20,
      paddingTop: 25,
      overflowX: 'auto',
      width: '100%',
      [theme.breakpoints.down(350)]: {
        paddingRight: theme.spacing(1),
      },
    },
    containerLink: {
      width: 250,
      overflow: 'hidden',
    },
    productPrice: {
      color: '#000000',
      fontSize: 21,
      height: 30,
      fontWeight: 'normal',
    },
    titlePriceOnce: {
      color: '#000000',
      fontSize: 15,
      height: 20,
      fontWeight: 'normal',
    },
    containerCount: {
      paddingLeft: 10,
      paddingRight: 10,
    },
    count: {
      color: '#000000',
      fontSize: 20,
      height: 24,
      fontWeight: 'normal',
      paddingTop: 3,
    },
    containerSum: {
      width: 200,
    },
    sum: {
      color: '#000000',
      fontSize: 21,
      height: 30,
      fontWeight: 'normal',
    },
    titleSum: {
      color: '#000000',
      fontSize: 15,
      height: 32,
      fontWeight: 'normal',
    },
    containerSumVendor: {
      paddingLeft: 20,
      paddingTop: 25,
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
    },
    wrapperSumVendor: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
    },
    titleVendorSum: {
      color: '#757575',
      fontSize: 21,
      height: 27,
      fontWeight: 'normal',
    },
    vendorSum: {
      color: '#000000',
      fontSize: 21,
      height: 27,
      fontWeight: 'normal',
      marginLeft: 10,
    },
    paymentStatus: {
      color: '#205373',
      fontSize: 21,
      height: 27,
      fontWeight: 'normal',
      marginLeft: 10,
    },
    requisites: {
      fontSize: 20,
      color: '#ffffff',
      fontWeight: 'normal',
    },
  };
});
